import { Component, Vue } from 'vue-property-decorator';
import * as dialogPolyfill from 'dialog-polyfill';
import router from './router';

@Component
export default class Mixin extends Vue {

  public To(path: any) {
    router.push(path);
  }

  public msg(obj: any) {
    let msg;
    if (obj.response) { // if obj is aws-amplify.API's error
      switch (obj.response.status) {
        case 403:
          msg = '許可がありません';
          break;
        case 404:
          msg = 'データが見つかりませんでした';
          break;
        case 400:
        case 405:
          msg = '接続方法に問題があります';
          break;
        case 422:
          msg = 'データが正しくありません';
          break;
        default:
          msg = 'サーバーでエラーが発生しました';
      }
    } else if (obj.code) { // if obj is cognito error
      window.console.log(obj);
      switch (obj.code) {
        case 'UserNotFoundException':
          msg = 'ユーザーが存在しません';
          break;
        case 'NotAuthorizedException':
          switch (obj.message) {
            case 'Incorrect username or password.':
              msg = 'ユーザー名かパスワードが間違っています';
              break;
            default:
              msg = '認証できませんでした';
          }
          break;
        case 'ExpiredCodeException':
          switch (obj.message) {
            case 'Invalid code provided, please request a code again.':
              msg = 'コードが正しくありません。もう一度パスワードリセットを行ってください。';
              break;
            default:
              msg = '認証で問題が発生しました';
          }
          break;
        case 'UnexpectedLambdaException':
          switch (obj.message) {
            case 'null invocation failed due to configuration.':
              msg = '値を空にすることはできません';
              break;
            default:
              msg = '認証に失敗しました';
          }
          break;
        case 'TooManyRequestsException':
          msg = 'リクエストが多すぎます';
          break;
        case 'InvalidParameterException': // パスワードの長さが正しくない?
        case 'InvalidPasswordException': // パスワードの形式が正しくない?
          msg = `パスワードの形式が正しくありません。以下の条件を満たしてください
・小文字を含む
・6文字以上`;
          break;
        case 'CodeMismatchException':
          msg = 'コードが間違っています';
          break;
        default:
          msg = 'ユーザー認証でエラーが発生しました';
      }
    } else {
      msg = obj.message || obj;
    }
    const snackbar: any = document.querySelector('#snackbar');
    snackbar.MaterialSnackbar.showSnackbar({ message: msg, timeout: 5000 });
  }

  public confirm(message: string, proc: () => void): void {
    const dialog = document.querySelector('dialog') as any;
    const close = dialog.querySelector('.close');
    const exec = dialog.querySelector('.exec');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    close.onclick = () => {
      dialog.close();
      close.innerHTML = 'キャンセル';
      exec.style.display = '';
    };
    dialog.querySelector('.mdl-dialog__content').innerHTML = `<p>${message}</p>`;
    if (proc) {
      exec.onclick = async () => {
        dialog.close();
        await proc();
      };
    } else {
      exec.style.display = 'none';
      close.innerHTML = '閉じる';
    }
    dialog.showModal();
  }

  public block() {
    (document.querySelector('#blocker') as HTMLElement).style.display = 'flex';
  }

  public unblock() {
    (document.querySelector('#blocker') as HTMLElement).style.display = 'none';
  }

  public isAdmin(): boolean {
    return this.$store.state.user.OrganizationID === '@' || this.$store.state.user.Admin[this.$store.state.showOrg];
  }

}
